import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})

export class ResourcesComponent {

  showLeftNav = false;
  appHeaderLeftAction = {
    icon: 'icon-menu',
    action: () => {
      this.showLeftNav = true;
    }
  };

  private resourceBaseUrl = environment.resourceBase;

  onDownloadAssetClick(assetUrl: string) {
    const fullUrl = this.resourceBaseUrl + assetUrl;
    window.open(fullUrl, '_blank');
  }
}
